/* eslint-disable no-nested-ternary */
import React, { useEffect, useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { moneyFormat } from '@helpers';
import moment from 'moment';
import { useNearScreen, useTransaction } from 'hooks';
import { useSelector, useDispatch } from 'react-redux';
import { setTransactionReference } from '@store/transactions/actions';
import { TitleAndTextInternalCard } from './TitleAndTextInternalCard';
import Error from './Error';
import CardSkeleton from './CardSkeleton';
import LoadingTransactions from '../../Titles/LoadingTransactions';
import { Text } from '../TransactionsDetailModal/TableTransactionsModal';

const Layout = styled.div`
  border-radius: 8px;
  background: var(--gray-gray-25, #fafafa);
  margin-bottom: 16px;
`;

const Row = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
`;

const Total = styled.div`
  color: #adadad;
  font-family: Roboto;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: 16px;
`;

const Price = styled.div`
  color: #505050;
  text-align: right;
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 20px;
`;

const FinalRow = styled(Row)`
  padding: 16px;
`;

const CardDetail = ({ handleCloseError, data }) => {
  const { t } = useTranslation();

  const [currentPage, setCurrentPage] = useState(1);

  const { getTransactionsDetails } = useTransaction();
  const externalRef = useRef();
  const { isNearScreen } = useNearScreen({ externalRef, once: false });

  useEffect(() => {
    if (isNearScreen) {
      setCurrentPage(currentPage + 1);
      getTransactionsDetails(data.details_transaction.reference_number, currentPage + 1);
    }
  }, [isNearScreen]);

  const { settlements: orderSummary, pagination } = useSelector(
    (state) => state.transactions.transactionDetails?.data || []
  );
  const { errorTransactionsDetails, loadingTransactionsDetails } = useSelector(
    (state) => state.transactions
  );

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setTransactionReference(data.details_transaction.reference_number));
    getTransactionsDetails(data.details_transaction.reference_number);
  }, []);
  return (
    <>
      {errorTransactionsDetails ? (
        <>
          <Error handleCloseError={handleCloseError} />
        </>
      ) : !orderSummary ? (
        <CardSkeleton />
      ) : (
        <>
          {orderSummary
            .filter((item) => item.payout?.centAmount > 0)
            .map((order) => (
              <Layout key={order.order}>
                <TitleAndTextInternalCard
                  title={t('transactions.modalDetail.numAccountState')}
                  text={order.number}
                  line
                />
                <Row>
                  <TitleAndTextInternalCard
                    title={t('transactions.modalDetail.dateOrder')}
                    text={moment(order.openedAt).format('DD/MM/YYYY HH:mm')}
                    line
                  />
                </Row>
                <FinalRow>
                  <Total>{t('transactions.modalDetail.amountToPay')}</Total>
                  <Price>
                    {moneyFormat(order.payout?.centAmount / (order.payout?.fraction || 1), true)}
                  </Price>
                </FinalRow>
              </Layout>
            ))}
          {orderSummary.length !== pagination.total && <div id="visor" ref={externalRef} />}
          {loadingTransactionsDetails && <LoadingTransactions mobile />}
          {orderSummary.length > 1 && orderSummary.length === pagination.total && (
            <Text>{t('transactionsFalabella.noMoreTransactions')}</Text>
          )}
        </>
      )}
    </>
  );
};

export default CardDetail;
